import classnames from 'classnames';
import React from 'react';

const Section = ({ children }) => (
	<div className="common-ui-layout-section">{children}</div>
);

const SectionBody = props => {
	const classNames = classnames(
		'section-body',
		props.hasOwnProperty('classNames') && props.classNames,
		{ 'no-padding': props.hasOwnProperty('noPadding') }
	);

	return (
		<div
			className={classNames}
			data-qa={props.dataqa || null}
			{...{ dataqa: props.dataqa || null }}
		>
			{props.children}
		</div>
	);
};

export { Section, SectionBody };
